<div class="app-content content">
  <div class="content-wrapper">
    <div class="content-header row mb-1">
     
    </div>
    <div class="content-body">
      <section id="drag-area">
        <div class="row">
          <div class="col-md-12" *blockUI="'changelog'; message: 'Loading'">
            <m-card  (reloadFunction)="reloadChangelog($event)">
              <ng-container mCardHeaderTitle>
               Sut Listesi <button class="btn btn-primary" (click)="openSutDecision()">SUT Karar Ağacı</button>
              </ng-container>
              <ng-container mCardBody>
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Adı</th>
                        
                       
                          <th>İşlemler</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let label of sutliste">
                        
                          <td>{{label.name}} </td>
                        
                         
                          <td>
                        <a routerLink="/sut/{{label.id}}"> <td><i class="la la-eye info" style="cursor: pointer;"></i></a>
                            
                          </td>
                        </tr>
                      </tbody>
                    </table>
               
              </ng-container>
            </m-card>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
